import React from "react";
import {
  PlaceForProc,
  PlaceForProcValidation,
} from "../../../../application/domain/proc-management";
import { ListInput } from "./list-input";
import { PlaceInputForProc } from "./place-input-for-proc";
import { InputProps, PathProps } from "./types";

const notices = ["申請を受け付けることができる窓口を列挙します。"];

type Props = InputProps &
  PathProps & {
    value: PlaceForProc[];
    isServiceProviderAccount: boolean;
    organizationId: string;
    validationErrors: PlaceForProcValidation[];
  };

export const ProcedureInPersonInfoPlacesListInput: React.FC<Props> = ({
  value,
  basePath,
  onChange,
  disabled,
  isServiceProviderAccount: isServiceProviderAccount,
  organizationId,
  shouldDisplayError,
  validationErrors,
}) => {
  return (
    <ListInput
      label="窓口申請受付場所"
      required
      component={PlaceInputForProc}
      componentProps={value.map((place, i) => ({
        id: place.id ?? "",
        name: place.name,
        counterName: place.counterName,
        usedIf: place.usedIf,
        orgId: organizationId,
        isServiceProviderAccount: isServiceProviderAccount,
        onChange,
        shouldDisplayError,
        validationErrors: validationErrors[i],
      }))}
      basePath={basePath}
      onPush={() => {
        onChange(basePath, [...value, {}]);
      }}
      onRemove={(i) => {
        onChange(basePath, [...value.slice(0, i), ...value.slice(i + 1)]);
      }}
      disabled={disabled}
      notices={notices}
    />
  );
};
